<ul class="downloadable-file-list">
    <ng-container *ngFor="let item of children" [appRenderNode]="item"></ng-container>
</ul>
